import * as React from "react";

import { cn } from "../lib/utils";
import { Icon, IconComponent, IconKey, IconProps } from "./icon";

type SpinnerProps = Omit<IconProps, "icon"> & {
  icon?: IconKey;
};

const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(
  ({ className, icon = "circleNotch", ...props }, ref): IconComponent => {
    return (
      <Icon
        className={cn("animate-spin text-inherit", className)}
        {...props}
        data-testid="spinner-icon"
        icon={icon}
        ref={ref}
      />
    );
  },
);

Spinner.displayName = "Spinner";

export { Spinner };
